import NavLinkInfo from "./NavLinkInfo";

// todo: generate league name, season, and phase from another component?

const links = {
  brand: new NavLinkInfo("brand", "brand", "/", null),
  search: new NavLinkInfo("search", "search", "/search", null),
  auth: {
    login: new NavLinkInfo("login", "login", "/login", null),
    signUp: new NavLinkInfo("signUp", "signup", "/sign-up", null),
    bell: new NavLinkInfo("bell", "bell", "/notifications", "auth"),
    user: new NavLinkInfo("user", "squarehe", "/users/squarehe", "auth"),
    logout: new NavLinkInfo("logout", "logout", "/logout", "auth"),
  },
  league: {
    name: new NavLinkInfo("name", "EWFL", "/ewfl/2020", "auth"),
    season: new NavLinkInfo("season", "2020", "/ewfl/2020", "auth"),
    week: new NavLinkInfo("week", "week 1", "/ewfl/2020/wk-01", "auth"),
    phase: new NavLinkInfo("phase", "preseason", "/ewfl/2020/wk-01", "auth"),
    links: [
      new NavLinkInfo("games", "games", "/ewfl/2020/games/wk-01", "auth"),
      new NavLinkInfo("players", "players", "/ewfl/2020/players", "auth"),
      new NavLinkInfo("standings", "standings", "/ewfl/2020/standings", "auth"),
    ],
    subLinks: [
      new NavLinkInfo("draft", "draft", "/ewfl/2020/draft", "auth"),
      new NavLinkInfo(
        "messageBoard",
        "message board",
        "/ewfl/2020/message-board",
        "auth"
      ),
      new NavLinkInfo(
        "powerRankings",
        "power rankings",
        "/ewfl/2020/power-rankings",
        "auth"
      ),
      new NavLinkInfo("rules", "rules", "/ewfl/2020/rules", "auth"),
    ],
  },
  team: {
    name: new NavLinkInfo("name", "Seoul Cobras", "/ewfl/2020/cobras", "auth"),
    logo: new NavLinkInfo("logo", "logo", "/ewfl/2020/cobras", "auth"),
    links: [
      new NavLinkInfo("roster", "roster", "/ewfl/2020/cobras/roster", "auth"),
      new NavLinkInfo("lineup", "lineup", "/ewfl/2020/cobras/lineup", "auth"),
    ],
    subLinks: [
      new NavLinkInfo("games", "games", "/ewfl/2020/cobras/games", "auth"),
      new NavLinkInfo("trades", "trades", "/ewfl/2020/cobras/trades", "auth"),
      new NavLinkInfo("info", "info", "/teams/cobras", "auth"),
    ],
  },
};

export default links;
